import { Table } from "@/pages/a7/Table";
import { Card } from "@heroui/react";
import i18n from "@/i18n";

// Define the types for the props and data
interface AuditTable {
  id: number;
  name: string;
}

interface Audit extends AuditTable {
  audit_action: string;
  audit_timestamp: string;
  audit_user_email: string;
}

// Define the props type
type AuditCardProps = {
  id: number;
  client: string;
  name: string;
  audit_columns: Array<any>; // Adjust based on the column structure
};

// Functional component definition using TypeScript
export function AuditCard<filterSchema>({
  id,
  client,
  name,
  audit_columns,
}: AuditCardProps) {
  return (
    <Card>
      <Table<Audit, filterSchema>
        label={i18n.t("audit.title", { defaultValue: "Audit" })}
        client={client}
        table_name={`${name}/audit`}
        columns={audit_columns}
        audit_id={Number(id)}
        download_button={false}
      />
    </Card>
  );
}
